import React from "react";

const StatCard = ({ label, value, tone = "default", helper, icon }) => (
  <article className={`stat-card stat-card--${tone}`}>
    <div className="stat-card__top">
      {icon && <div className="stat-card__icon">{icon}</div>}
    </div>
    <div className="stat-card__value">{value}</div>
    <div className="stat-card__label">{label}</div>
    {helper && <small style={{ fontSize: "0.75rem", color: "var(--text-muted)" }}>{helper}</small>}
  </article>
);

export default StatCard;
